var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitterBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M195.519,424.544c135.939,0,210.268-112.643,210.268-210.268c0-3.218,0-6.437-0.153-9.502     c14.406-10.421,26.973-23.448,36.935-38.314c-13.18,5.824-27.433,9.809-42.452,11.648c15.326-9.196,26.973-23.602,32.49-40.92     c-14.252,8.429-30.038,14.56-46.896,17.931c-13.487-14.406-32.644-23.295-53.946-23.295c-40.767,0-73.87,33.104-73.87,73.87     c0,5.824,0.613,11.494,1.992,16.858c-61.456-3.065-115.862-32.49-152.337-77.241c-6.284,10.881-9.962,23.601-9.962,37.088     c0,25.594,13.027,48.276,32.95,61.456c-12.107-0.307-23.448-3.678-33.41-9.196v0.92c0,35.862,25.441,65.594,59.311,72.49     c-6.13,1.686-12.72,2.606-19.464,2.606c-4.751,0-9.348-0.46-13.946-1.38c9.349,29.426,36.628,50.728,68.965,51.341     c-25.287,19.771-57.164,31.571-91.8,31.571c-5.977,0-11.801-0.306-17.625-1.073c32.337,21.15,71.264,33.41,112.95,33.41Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterBlack);
export default __webpack_public_path__ + "static/media/twitter_black.e3f447029d3d9c9ea8caac1f7d440f05.svg";
export { ForwardRef as ReactComponent };